import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import BreadCrumb from "./breadcrumbs";
import "../../../assets/css/design/main/sidebar/adminLayout.css";

function Navbar({
  nickname,
  roleAccess,
  mobileOpen,
  setMobileOpen,
  collapsed,
  setCollapsed
}) {
  const handleToggle = () => {
    // Check if on mobile or desktop
    if (window.innerWidth < 1024) {
      if (setMobileOpen) setMobileOpen(!mobileOpen);
    } else {
      if (setCollapsed) setCollapsed(!collapsed);
    }
  };

  return (
    <header className="admin-navbar">
      <div className="admin-navbar-left">
        <button
          type="button"
          className="admin-sidebar-toggle-btn"
          onClick={handleToggle}
          title="Toggle Menu"
          aria-label="Toggle Sidebar"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
        <BreadCrumb />
      </div>

      <div className="admin-navbar-right">
        {nickname && (
          <div className="admin-header-user-chip">
            <span>👋 Halo, <strong>{nickname}</strong></span>
            {roleAccess && <span className="chip-role">{roleAccess}</span>}
          </div>
        )}
      </div>
    </header>
  );
}

export default Navbar;